import React from "react"
import Card from "../card/Card"
import * as classNames from "./PressArticleCard.module.scss"
import Image from "../image/Image"
import Icon from "../icon/Icon"
import { formatDate } from "../../../../../utils/formatDate"
import { Link } from "gatsby-plugin-modal-routing-3"
function PressArticleCard({ data }) {

  return (
    <div className={classNames.pressCardArticleContainer + " xxlarge"}>
      <Card className={classNames.pressCardArticle}>
        <Card className={classNames.pressImg}>
        <a
           href={ data.attributes.url}
           target={"_blank" }
           style={{height: "100%", width: "100%" }}
          >
          <Image
            dataSizesPreset={"S"}
            formats={data.attributes.image?.data.attributes.formats}
            imgSrc={data.attributes.image?.data.attributes.url}
            imgAlt={data.attributes.image?.data.attributes.alternativeText}
            imgHeight="250"
            imgWidth="100%"
            loading="lazy"
            className={classNames.img + " centered"}
          />
          </a>
          <div className={`${classNames.date}`}>
            <time>{formatDate(data?.attributes.date)}</time>
          </div>
        </Card>
        <div className={classNames.pressContent}>
        <a
           href={ data.attributes.url}
           target={"_blank" }
           style={{ textDecoration: "none", color: "inherit"}}
          >
          <h3>{data.attributes.title}</h3>
          </a>
          <p>{data.attributes.description}</p>
          <div className={classNames.pressDate}>
            <div className={classNames.iconContainer}>
              <div className={`${classNames.date}`}>
                <time>{formatDate(data?.attributes.date)}</time>
              </div>
              <div className={classNames.icon}>
                <Icon
                  icon="calendar"
                  color="var(--gris)"
                  width="20px"
                  height="20px"
                />
              </div>
            </div>
            <div className={classNames.learnMore}>
              <Link
                aspect="unstyled"
                size="small"
                color="primary"
                className="underline flex"
                to={data.attributes.url}
                target={"_blank" }
              >
                <Icon icon="arrowRightLink" /> Lire l’article
              </Link>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default PressArticleCard
